import { useState, useEffect, useContext } from "react";
import { ReservationsContext } from "../context/ReservationsContext";
import { AvailableClassesContext } from "../context/AvailableClassesContext";
import { SingleClassContext } from "../context/SingleClassContext";
import { WaitlistsContext } from "../context/WaitlistsContext";
import { ModalContext } from "../context/ModalContext";
import { AuthContext } from "../context/AuthContext";
import utils from "../components/clases/utils";
import { LocationsContext } from "../context/LocationsContext";
import { ClassTypeContext } from "../context/ClassTypesContext";

const useSchedule = ({ view = "week", instructor_id }) => {
  const [location, setLocation] = useState("");
  const [classType, setClassType] = useState("");

  const {
    days,
    update,
    spinner,
    end_date,
    start_date,
    setEndDate,
    getSchedule,
    setStartDate,
  } = useContext(SingleClassContext);
  
  const { clearModal } = useContext(ModalContext);
  const { locations, getLocations } = useContext(LocationsContext);
  const { class_types, getClassTypes } = useContext(ClassTypeContext);
  const { user, getUsuario } = useContext(AuthContext);
  const { getWaitlists } = useContext(WaitlistsContext);
  const { getMyReservations } = useContext(ReservationsContext);
  const { getAvailableClasses } = useContext(AvailableClassesContext);

  useEffect(() => {
    getLocations();
    getClassTypes();
    if (user !== null) {
      getMyReservations({ page: 1 });
      getAvailableClasses();
      getWaitlists();
      if (user.location_id) {
        setLocation(user.location_id);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    const date = utils.getStartDate(view);
    setStartDate(date);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [view]);

  useEffect(() => {
    setEndDate(utils.getEndDate(view, start_date));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [start_date]);

  useEffect(() => {
    fetchSchedule();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [instructor_id, start_date, end_date, update]);

  const fetchSchedule = () => {
    if (user !== null) getMyReservations({ page: 1 });
    if (utils.validDates(start_date, end_date)) {
      getSchedule({ start_date, end_date, instructor_id });
    }
  };

  const handleCallback = () => {
    fetchSchedule();
    getUsuario();
    clearModal();
  };

  const handleNextWeek = () => {
    setStartDate(utils.getStartNext("week", start_date));
  };

  const handlePrevWeek = () => {
    setStartDate(utils.getStartPrev("week", start_date));
  };

  const handleNextMonth = () => {
    setStartDate(utils.getStartNext("month", start_date));
  };

  const handlePrevMonth = () => {
    setStartDate(utils.getStartPrev("month", start_date));
  };

  return {
    days,
    spinner,
    location,
    classType,
    end_date,
    start_date,
    locations,
    class_types,
    setLocation,
    setClassType,
    fetchSchedule,
    handleNextMonth,
    handlePrevMonth,
    handleNextWeek,
    handlePrevWeek,
    handleCallback,
  };
};

export default useSchedule;
